Student Dashboard for user <b>{{userProfile.userName}}</b>